import React from 'react';
import { IProps } from './types';
import * as Styled from './styles';

export const Title: React.FC<IProps> = ({ toggleVisible, title, isVisible, htmlEl }) => (
  <Styled.Wrapper $isVisible={isVisible} onClick={toggleVisible} className="accordion-box-title">
    <Styled.Text as={htmlEl as never} className="accordion-box-title-text">
      {title}
    </Styled.Text>
    <Styled.ArrowButton aria-expanded={isVisible} className="accordion-box-title-arrow">
      <Styled.ArrowIcon $isVisible={isVisible} />
    </Styled.ArrowButton>
  </Styled.Wrapper>
);

export default Title;
